const updateStockIndicator = (stockIndicator, variantStock) => {
  stockIndicator.dataset.stockAmount = variantStock;

  const stock = Number(stockIndicator.dataset.stockAmount);
  const threshold = Number(stockIndicator.dataset.lowStockThreshold);

  const messages = {
    instock: stockIndicator.querySelector('[data-stock-in-stock]'),
    lowstock: stockIndicator.querySelector('[data-stock-low-stock]'),
    oos: stockIndicator.querySelector('[data-stock-out-of-stock]'),
  };

  const showMessage = (key) => {
    Object.entries(messages).forEach(([name, el]) => {
      el.classList.toggle('hidden', name !== key);
    });
  };

  if (stock <= 0) showMessage('oos');
  else if (stock <= threshold) showMessage('lowstock');
  else showMessage('instock');
};

export default updateStockIndicator;